export { FavoritePublicationsScreen as default } from '@/src/features/publication/ui/screens/FavoritePublicationsScreen'
